import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { Box, Collapse, IconButton, Stack, Typography } from '@mui/material';
import { type ReactNode, useState } from 'react';

import { ClickableBox } from 'src/uiKit/ClickableBox';

interface CollapsibleOptionsProps {
  title?: string;
  children: ReactNode;
  disableTopMargin?: boolean;
}

export const CollapsibleOptions = ({
  title = 'Additional options',
  children,
  disableTopMargin,
}: CollapsibleOptionsProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ bgcolor: 'background.neutral', borderRadius: 1, mt: disableTopMargin ? 0 : 2, p: 2 }}>
      <ClickableBox onClick={() => setOpen(!open)} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="subtitle1">{title}</Typography>
          <IconButton size="small">
            <ExpandMoreRounded
              sx={{
                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }}
            />
          </IconButton>
        </Stack>
      </ClickableBox>
      <Collapse in={open}>{children}</Collapse>
    </Box>
  );
};
